module.exports = __webpack_public_path__ + "static/media/Banner membresía diamond.c34ddf82.svg";